<div class="page-wrapper">
  <div class="subheader-principal">
    <div class="container">
      <div class="subheader-content">
        <div class="address">
          779 Lakeside Dr, Mobile, AL, 36693
        </div>
        <div class="phone">
          <a href="https://wa.me/12519016034">+1 251 901-6034</a>
        </div>
      </div>
    </div>
  </div>
  <app-header 
    [totalItemsCart]="totalItemsCart"
    (toggleSidenavEvent)="toggleSidenav()">
  </app-header>
  <div class="carousel-container">
    <owl-carousel-o [options]="customOptions" *ngIf="slidesStore && slidesStore.length > 0">
      <ng-container *ngFor="let slide of slidesStore">
        <ng-template carouselSlide [id]="slide.id">
          <div class="carousel-slide lg" [style.background-image]="'url(' + slide.src_web_lg + ')'"></div>
          <div class="carousel-slide md" [style.background-image]="'url(' + slide.src_web + ')'"></div>
          <div class="carousel-slide sm" [style.background-image]="'url(' + slide.src_mobile + ')'"></div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>

  <div class="container">
    <div>
      <div class="row subheader" *ngIf="categories.length > 0">
        <div class="col-12 mt-3">
          <div class="search-container">
            <div class="form-group has-search m-0">
              <span class="form-control-feedback"><img src="assets/images/icons/magnifying-glass.png" style="height: 14px;" alt=""></span>
              <input type="text" class="form-control input-filter rounded-lg" id="inputSearch" (keyup)="filterProducts($event.target.value)" placeholder="Search for products...">
              <span class="form-control-search clean-button" *ngIf="cleanButton" (click)="cleanSearch()" style="cursor: pointer;"> 
                <img src="assets/images/icons/clean.png" style="height: 16px;" alt="">
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-3 mt-3 px-3">
          <app-categorias [data]="categories" (categorySelected)="onCategorySelected($event)"></app-categorias>
        </div>
       <!-- <div class="col-md-12 d-flex justify-content-end align-items-center my-1">
          <p class="mt-0 mb-0">Total items: <span class="font-weight-bold">{{totalItems}}</span></p>
        </div> -->
      </div>
      <!-- PRODUCTOS -->
 
      <div class="row relative">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 p-md-0">
          <div class="products products-table" id="listPrincipal">
            <div class="product box rounded-lg-10 shadow-minimal" (click)="verProducto(product.sku)" *ngFor="let product of filteredData | filterProducts:filterargs; let i = index ">
              <div class="product-img-container">
                <div class="product-img rounded-lg" [style.background-image]="getProductImageUrl(product.url)"
                     fallbackImage>
                </div>
                <div class="lowest-price" *ngIf="getLowestPrice(product.precios) > 0">
                  <span>from</span> ${{ getLowestPrice(product.precios) }}
                </div>
              </div>
              <div class="product-content">
                <h3>
                  {{product.nombre}}
                  <small>{{product.unidad  | titlecase}}</small>
                </h3>
                <span class="presentaciones">{{product.presentaciones}}</span>
                <p>
                  {{product.descripcion}}
                </p>
              </div>
            </div>
            <!-- Mensaje modificado para "No products found" -->
            <div *ngIf="!isLoading && (filteredData | filterProducts:filterargs).length === 0" class="no-products-message">
              <p>No products found.</p>
            </div>

            <!-- Opcional: Agregar un indicador de carga -->
            <div *ngIf="isLoading" class="no-products-message">
              <p>Loading products...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Ir al carrito y total -->

  <div class="bottom-div cssanimation sequence bounceInBottom d-md-none" *ngIf="totalItemsCart>0">
    <div class="row h-100">
      <div class="col-lg-6 col-5">
        <div class="d-block text-total h-100 pt-3">
          <p class="mb-0">Total</p>
          <h6 class="font-weight-bold">$ {{totalPriceCart | separadormiles }}</h6>
        </div>
      </div>
      <div class="col-lg-6 col-7">
        <div class="container pt-3">
          <button (click)="showCart()" class="btn btn-lg btn-light font-weight-bold px-3 float-right"><mat-icon svgIcon="cart"></mat-icon>&nbsp;&nbsp;View cart</button>
        </div>
      </div>
    </div>

  </div>
